export enum PropertyTypes {
  TWO_FAMILY_DETACHED_HOUSE = 'TWO_FAMILY_DETACHED_HOUSE', // 2 Families Hus
  COMMERCIAL_AND_PRIVATE = 'COMMERCIAL_AND_PRIVATE', // Bolig / Erhverv
  COMMERCIAL_WITH_RESIDENCE = 'COMMERCIAL_WITH_RESIDENCE', // Erhverv med Bolig
  RESIDENTIAL_PROPERTY = 'RESIDENTIAL_PROPERTY', // Boligejendom
  TERRACED_HOUSE = 'TERRACED_HOUSE', // Rækkehus
  DETACHED_HOUSE = 'DETACHED_HOUSE', // Villa
  SHARED_OWNERSHIP_DETACHED_HOUSE = 'SHARED_OWNERSHIP_DETACHED_HOUSE', // Villa (alternative key)
}
